import * as React from "react";
import { Tab, Tabs } from "@blueprintjs/core";
import { useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { useHistory, useParams } from "react-router";
import styled from "styled-components";
import { ERoutes } from "../../../../ERoutes";
import { PersonBreedGroupJudgePage } from "./personJudge/PersonBreedGroupJudgePage";
import { PersonBreedJudgePage } from "./personJudge/PersonBreedJudgePage";
import { PersonSubActivityJudgePage } from "./personJudge/PersonSubActivityJudgePage";
import { PersonJudgeHierarchyPage } from "./personJudge/PersonJudgeHierarchyPage";
import { PersonJudgeInfoPage } from "./PersonJudgeInfoPage";

export interface IPersonJudgeTabsProps {}

const StyledContainer = styled.div`
  & > * {
    margin-top: 2rem;
  }
`;

export const PersonJudgeTabs: React.FunctionComponent<IPersonJudgeTabsProps> = (props) => {
  const { t } = useTl();
  const history = useHistory();
  const { id, state, judgeTab } = useParams<{ id: string; state: string; judgeTab: string }>();
  const [dataUpdated, setDataUpdated] = React.useState("");

  return (
    <Tabs
      id="tabsPersonJudge"
      onChange={(newTabId) => {
        history.push(`${ERoutes.people}/${id}/judge/${state}/${newTabId}`);
      }}
      selectedTabId={judgeTab}
      vertical
    >
      <Tab
        id="detail"
        title={t(ETLCodes.Detail)}
        panel={
          <StyledContainer>
            <PersonJudgeInfoPage personId={+id} editMode={state === "edit"} />
            <PersonBreedGroupJudgePage
              onUpdated={(updId) => {
                setDataUpdated(updId);
              }}
            />
            <PersonBreedJudgePage
              personId={+id}
              editMode={state === "edit"}
              onUpdated={(updId) => {
                setDataUpdated(updId);
              }}
            />
            <PersonSubActivityJudgePage personId={+id} editMode={state === "edit"} />
          </StyledContainer>
        }
        panelClassName="full-width-panel"
      />
      <Tab
        id="global"
        title={t(ETLCodes.Global)}
        panel={
          <StyledContainer>
            <PersonJudgeHierarchyPage personId={+id} doUpdate={dataUpdated} />

            <PersonSubActivityJudgePage personId={+id} editMode={state === "edit"} />
          </StyledContainer>
        }
        panelClassName="full-width-panel"
      />
    </Tabs>
  );
};
